import {
  Component,
  input,
  OnChanges,
  SimpleChanges,
  effect,
} from "@angular/core";
import { MigrationStatus } from "@app/common/constants";

//export type ProgressStatus = "pending" | "in-progress" | "completed" | "failed";

@Component({
  selector: "app-progress-tracker",
  standalone: false,
  templateUrl: "./progress-tracker.component.html",
  styleUrls: ["./progress-tracker.component.scss"],
})
export class ProgressTrackerComponent {
  progress = input<number | undefined>(0);
  status = input<MigrationStatus | undefined>(MigrationStatus.in_progress);
  showPercentage = input<boolean>(true);
  height = input<number>(8); // Default height in pixels
  label = input<string | undefined>("");
  extraLabel = input<string | undefined>("");
  tooltipText = input<string>("");
  animateProgress = input<boolean>(true); // New flag to control animation

  // Calculated properties
  displayProgress: number = 0;
  statusColor: string = "primary";
  statusIcon: string = "hourglass_empty";
  isComplete: boolean = false;

  constructor() {
    // Use effect to react to signal changes
    effect(() => {
      // Ensure progress is between 0-100
      this.displayProgress = Math.max(0, Math.min(100, this.progress() || 0));
      this.isComplete = this.displayProgress === 100;

      // Update status display based on progress or status changes
      this.updateStatusDisplay();
    });
  }

  private updateStatusDisplay(): void {
    switch (this.status()) {
      case MigrationStatus.migrating:
        this.statusColor = "accent";
        this.statusIcon = "hourglass_empty";
        break;
      case MigrationStatus.in_progress:
        this.statusColor = "primary";
        this.statusIcon = "sync";
        break;
      case MigrationStatus.migrated:
        this.statusColor = "success";
        this.statusIcon = "check_circle";
        break;
      case MigrationStatus.exception:
        this.statusColor = "error";
        this.statusIcon = "error";
        break;
      default:
        this.statusColor = "warn";
        this.statusIcon = "error";
        break;
    }

    // Auto-set status based on progress if not explicitly set
    // if (this.progress === 100 && this.status === "in-progress") {
    //   this.status = "completed";
    //   this.statusColor = "primary";
    //   this.statusIcon = "check_circle";
    // }
  }

  get progressBarStyle(): any {
    return {
      "height.px": this.height(),
    };
  }

  get showRunningIndicator(): boolean {
    return (
      //this.animateProgress() &&
      this.status() === MigrationStatus.in_progress // &&
      //this.displayProgress < 100
    );
  }

  get runningIndicatorStyle(): any {
    const tipPosition = Math.max(2, Math.min(98, this.displayProgress));

    return {
      left: `${tipPosition}%`,
    };
  }
}
